import { keyframes } from 'styled-components';

import { hexToRGB } from '@/styles/helpers';

export const AnimationHideKeyframes = keyframes`
  0%{
    transform: translateX(100%)
  }
  4%{
    transform: translateX(0);
    opacity: 1;
  }
  80%{
    opacity: 1;
  }
  100%{
    opacity: 0
  }
`;

export const AnimationTopHideKeyframes = keyframes`
  0%{
    transform: translateY(-100%)
  }
  4%{
    transform: translateY(0);
    opacity: 1;
  }
  80%{
    opacity: 1;
  }
  100%{
    opacity: 0
  }
`;

export const show = keyframes`
  0% {opacity: 0;}
  100% {opacity: 1;}
`;

export const pulseShadow2 = (color: string) => keyframes`
  0% {
    box-shadow: 0 0 0 0 ${hexToRGB(color, 0.6)};
  }
  70% {
      box-shadow: 0 0 0 6px ${hexToRGB(color, 0)};
  }
  100% {
      box-shadow: 0 0 0 0 ${hexToRGB(color, 0)};
  }
`;

export const pulseShadow3 = (color: string) => keyframes`
  0% {
      box-shadow: 0 0 0 0 ${hexToRGB(color, 1)};
  }
  50% {
      box-shadow: 0 0 0 10px ${hexToRGB(color, 0)};
  }
  100% {
      box-shadow: 0 0 0 50px ${hexToRGB(color, 0)};
  }
`;
